<fe-header style="z-index: 10000"></fe-header>
<main>
    <section class="section-alamo-b2b container-xl py-5">
        <div class="row align-items-center">
            <!-- Columna izquierda: texto -->

            <div class="col-12 col-lg-6 text-center text-lg-start mb-4 mb-lg-0">
                <h2 class="b2b-title">
                    <span class="text-blue">Gracias por contactarnos.</span
                    ><br />
                </h2>
                <p class="b2b-subtitle">
                    Hemos recibido tu información y uno de nuestros ejecutivos
                    se pondrá en contacto contigo a la brevedad.
                </p>
                <a
                    [routerLink]="['/es/empresas-new']"
                    class="btn btn-unete fw-bold px-4 py-2 mt-3"
                >
                    Ir al home
                </a>
            </div>

            <!-- Columna derecha: imagen -->
            <div class="col-12 col-lg-6 text-center">
                <img
                    [src]="'images/alamo-b2b-equipo.jpg' | cdn"
                    alt="Alamo B2B equipo"
                    class="img-fluid b2b-img rounded-4"
                />
            </div>
        </div>
    </section>
</main>
<fe-footer></fe-footer>
